export default __webpack_public_path__ + "static/media/smoothie_ginger.97899312.png";